
import {DisplaySingleContact} from './DisplaySingleContact'


const DisplayContacts = ({ prompts, onDelete }) => {

  var count = 0;

  

  return (
    <div>
      <div>Total: {prompts.length}</div>
      {prompts?.map((prompt, idx) => {
        count += 1
        return (<DisplaySingleContact
          count={count}
          key={prompt.id}
          prompt={prompt}
          onDelete={onDelete}
          />
        )
      })}
      
    </div>
  )
}

export default DisplayContacts